import { connect } from 'react-refetch';
import cache from 'helpers/fetchCache';
import * as Sentry from '@sentry/react';
import getRuntimeEnv from './env';

const checkAllowCacheRequest = (url: string): boolean =>
  url.indexOf('/exporting/jobs') === -1 &&
  url.indexOf('/customEntityLists/') === -1;

async function cachingFetch(input: any, init: any): Promise<Response> {
  const req = new Request(input, init);

  const cached = cache.get(req.url);

  if (cached) {
    const response = await cached;
    return response.clone();
  }

  const fetchPromise = (async (): Promise<Response> => {
    const response = await fetch(req);

    if (response.ok) {
      if (checkAllowCacheRequest(req.url)) {
        cache.set(req.url, response.clone());
      }
    } else {
      // Log to console
      // eslint-disable-next-line no-console
      console.error(
        'An error occurred in an API request.',
        new Error(response.statusText),
        { response: response, requestUrl: req.url }
      );

      // Report to Sentry
      if (getRuntimeEnv().REACT_APP_SENTRY_DSN) {
        Sentry.captureException(new Error(response.statusText));
      }
    }

    return response;
  })();

  if (checkAllowCacheRequest(req.url)) {
    cache.set(req.url, fetchPromise);
  }

  return fetchPromise;
}

export default connect.defaults({ fetch: cachingFetch as any });
